import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import FloatingButton from '@Components/utils/floating-button/floating-button.component';
import UserBugReportComponent from '@Components/user/user-bug-report/user-bug-report.component';

const ArmyListSupportComponent: React.FC<Props> = ({}) => {
  const [isReportOpen, setIsReportOpen] = React.useState(false);

  return (
    <>
      {!isReportOpen && (<FloatingButton>
        <div className="sub-button">
          <a href={process.env.DISCORD ?? '#'} target="_blank">
            <i className="fa-brands fa-discord"></i>
          </a>
        </div>
        <div className="sub-button">
          <a href="#" onClick={() => setIsReportOpen(true)}>
            <i className="fa-solid fa-bug"></i>
          </a>
        </div>
      </FloatingButton>)}

      {isReportOpen && (<UserBugReportComponent onClose={() => setIsReportOpen(false)} />)}
    </>
  );
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListSupportComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
